"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Utils = require("../Utils");
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const Container = exports.Container = (0, _styledComponents.default)(_Utils.Button).withConfig({
  shouldForwardProp: prop => !['circle', 'danger', 'secondary'].includes(prop)
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    align-items: center;\n    background-color: ", ";\n    border-radius: ", ";\n    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);\n    color: ", ";\n    cursor: ", ";\n    display: flex;\n    flex-direction: ", ";\n    height: ", "px;\n    justify-content: center;\n    ", "\n    position: relative;\n    transition: all 200ms ease;\n    width: ", "px;\n\n    :focus,\n    :hover {\n        box-shadow: 0px 0px 1px 1px ", ";\n        ", "\n    }\n\n    :focus,\n    :focus-within {\n        box-shadow: 0px 0px 1px 1px ", ";\n    }\n\n    ::before {\n        content: '';\n        background-color: white;\n        border-radius: ", ";\n        bottom: 0;\n        left: 0;\n        position: absolute;\n        right: 0;\n        top: 0;\n        transform: ", ";\n        transition: all 200ms ease;\n    }\n\n    :focus::before,\n    :hover::before {\n        ", "\n    }\n"])), _ref => {
  let {
    color,
    danger,
    disabled,
    secondary,
    theme: {
      dangerColor,
      disabledColor,
      primaryColor
    }
  } = _ref;
  return danger ? dangerColor : !disabled && !secondary ? color !== null && color !== void 0 ? color : primaryColor : disabledColor;
}, _ref2 => {
  let {
    circle
  } = _ref2;
  return !!circle ? '50%' : '20px';
}, _ref3 => {
  let {
    color,
    danger,
    disabled,
    loading,
    theme: {
      dangerColor,
      overPrimaryColor = '#FFFFFF',
      primaryColor
    }
  } = _ref3;
  return loading ? color !== null && color !== void 0 ? color : !!danger ? dangerColor : primaryColor : !!danger || !!disabled ? '#FFFFFF' : overPrimaryColor;
}, (0, _Utils.ifProp)('disabled', 'auto', 'pointer'), _ref4 => {
  let {
    iconPosition
  } = _ref4;
  return iconPosition === 'right' ? 'row-reverse' : 'row';
}, _ref5 => {
  let {
    circle,
    size
  } = _ref5;
  return !!circle ? size : size / 2;
}, _ref6 => {
  let {
    margin
  } = _ref6;
  return margin ? "margin: ".concat(margin, ";") : '';
}, _ref7 => {
  let {
    size,
    width
  } = _ref7;
  return width !== null && width !== void 0 ? width : size;
}, _ref8 => {
  let {
    danger,
    disabled,
    theme: {
      dangerColor,
      disabledColor,
      primaryColor
    }
  } = _ref8;
  return disabled ? disabledColor : danger ? dangerColor : primaryColor;
}, _ref9 => {
  let {
    color,
    danger,
    disabled,
    secondary,
    theme: {
      dangerColor,
      disabledColor,
      primaryColor
    }
  } = _ref9;
  return !!disabled ? '' : "color: ".concat(danger ? dangerColor : secondary ? disabledColor : color !== null && color !== void 0 ? color : primaryColor, ";");
}, _ref0 => {
  let {
    danger,
    disabled,
    theme: {
      dangerColor,
      disabledColor,
      primaryColor
    }
  } = _ref0;
  return disabled ? disabledColor : danger ? dangerColor : primaryColor;
}, _ref1 => {
  let {
    circle
  } = _ref1;
  return !!circle ? '50%' : '20px';
}, _ref10 => {
  let {
    loading
  } = _ref10;
  return loading ? 'scale(1)' : 'scale(0)';
}, _ref11 => {
  let {
    disabled
  } = _ref11;
  return !!disabled ? '' : "\n            transform: scale(1);\n        ";
});
const Text = exports.Text = _styledComponents.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: ", "px;\n    font-weight: 500;\n    text-align: center;\n    padding: 5px;\n    z-index: 1;\n"])), _ref12 => {
  let {
    fontSize
  } = _ref12;
  return fontSize;
});